// TwitchEmbed.tsx
import { useEffect, useRef } from "react";

interface TwitchEmbedProps {
  channel: string;
  width?: string;
  height?: string;
}

const TwitchEmbed = ({ channel, width = "100%", height = "480" }: TwitchEmbedProps) => {
  const embedRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("src", "https://embed.twitch.tv/embed/v1.js");
    script.async = true;

    script.onload = () => {
      if ((window as any).Twitch && embedRef.current) {
        new (window as any).Twitch.Embed(embedRef.current.id, {
          width,
          height,
          channel,
          layout: "video",
          autoplay: true,
        });
      }
    };

    document.body.appendChild(script);
  }, [channel, width, height]);

  return <div id="twitch-embed" ref={embedRef}></div>;
};

export default TwitchEmbed;
